import styled from '@emotion/styled';
import Box from './layouts/Box';
import { useTheme } from '@emotion/react';

const CardStyling = styled(Box)();

const Card = (props) => {
  const {cardStyleOverwrite} = useTheme();
  const cardStyle = {
    maxWidth: 1024,
    bg: 'white',
    borderRadius: 4,
    p: {mobile: 'm', desktop: 'xl'},
    border: 'default',
  }

  return <CardStyling {...cardStyle} {...cardStyleOverwrite} {...props} />
}

export default Card;
